export const gPatterns = [
  /* --------------------- G -------------------- */
  {
    value: "G Straight ",
    label: "G Straight ",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "I", "N", "O"],
    credit: null,
  },
  {
    value: "Gift",
    label: "Gift",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, false, true, true, true],
      N: [false, true, true, true, true],
      G: [true, false, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "O"],
    credit: "Denise S",
  },
  {
    value: "Ghost",
    label: "Ghost",
    otherNames: [],
    pattern: {
      B: [false, true, true, false, false],
      I: [true, false, false, true, true],
      N: [true, false, false, false, false],
      G: [true, false, false, true, true],
      O: [false, true, true, false, false],
    },
    unusedLetters: [],
    credit: "Patricia Morrison",
  },
  {
    value: "GO",
    label: "GO",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [true, true, true, true, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["B", "I", "N"],
    credit: null,
  },
  {
    value: "Goal Post",
    label: "Goal Post",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, false],
      I: [false, false, true, false, false],
      N: [false, false, true, true, true],
      G: [false, false, true, false, false],
      O: [true, true, true, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Goal Post (Alternate)",
    label: "Goal Post (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, true, true, true, true],
      I: [false, false, true, false, false],
      N: [false, false, true, false, false],
      G: [false, false, true, false, false],
      O: [false, true, true, true, true],
    },
    unusedLetters: ["N"],
    credit: "Joe Pfanzelter",
  },
  {
    value: "Golden 8",
    label: "Golden 8",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, false],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: [],
    credit: "MSDX",
    winningPatterns: [
      {
        B: [false, true, true, true, false],
        I: [true, false, false, false, true],
        N: [false, true, true, true, false],
        G: [true, false, false, false, true],
        O: [false, true, true, true, false],
      },
    ],
  },
  {
    value: "Golden 8 (Alternate)",
    label: "Golden 8 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, false],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: [],
    credit: "Jass",
    winningPatterns: [
      {
        B: [false, true, true, true, false],
        I: [true, false, false, false, true],
        N: [false, true, true, true, false],
        G: [true, false, false, false, true],
        O: [false, true, true, true, false],
      },
    ],
  },
  {
    value: "Golden 8 Bingo",
    label: "Golden 8 Bingo",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, false],
      I: [true, false, true, false, true],
      N: [true, false, false, false, true],
      G: [true, false, true, false, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [false, true, true, true, false],
        I: [true, false, false, false, true],
        N: [false, true, true, true, false],
        G: [true, false, false, false, true],
        O: [false, true, true, true, false],
      },
      {
        B: [false, true, false, true, false],
        I: [true, false, true, false, true],
        N: [true, false, true, false, true],
        G: [true, false, true, false, true],
        O: [false, true, false, true, false],
      },
      {
        B: [false, true, true, true, false],
        I: [true, false, false, false, true],
        N: [false, true, false, true, false],
        G: [true, false, false, false, true],
        O: [false, true, true, true, false],
      },
    ],
  },
  {
    value: "Golf Bag",
    label: "Golf Bag",
    otherNames: [],
    pattern: { B: [true, true, false, false, false], I: [true, true, true, false, false], N: [false, true, true, true, false], G: [true, false, true, true, true], O: [true, true, false, true, true] },
    unusedLetters: [],
    credit: "VFW Post 3596",
    winningPatterns: [{ B: [true, true, false, true, true], I: [true, false, true, true, true], N: [false, true, true, true, false], G: [true, true, true, false, false], O: [true, true, false, false, false] }],
  },
  {
    value: "Grass",
    label: "Grass",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [false, true, true, true, true],
      G: [false, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I", "G"],
    credit: null,
  },
  {
    value: "Greater",
    label: "Greater",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [false, true, false, true, false],
      N: [false, false, true, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["N", "G", "O"],
    credit: null,
  },
  {
    value: "Growing That Pot Leaf",
    label: "Growing That Pot Leaf",
    otherNames: [],
    pattern: {
      B: [false, false, true, false, true],
      I: [false, false, false, true, true],
      N: [true, true, true, true, true],
      G: [false, false, false, true, true],
      O: [false, false, true, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
];
